module.exports = __webpack_public_path__ + "img/item_CommIllustration_03b.a2964857.jpeg";